import Vue from 'vue';

import VueRouter from 'vue-router';
import createRouter from '@/router';
import createStore, { getInitialState } from '@/store';
import Buefy from 'buefy';
import '@/styles/app.scss';
import { backend, HttpPlugin } from '@/config/http';
import MomentPlugin from '@/config/moment';
import * as filters from '@/filters';
import VueAnalytics from 'vue-analytics';
import App from './App';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(Buefy);
Vue.use(new HttpPlugin(backend, '$http'));
Vue.use(new MomentPlugin());


Object.entries(filters).forEach(([key, filter]) => {
  Vue.filter(key, filter);
  Vue.prototype[`$${key}`] = filter;
});

getInitialState().then((initialState) => {
  const store = createStore(initialState);
  const router = createRouter({ store });
  if (process.env.VUE_APP_GA) {
    const isProd = process.env.NODE_ENV === 'production';

    Vue.use(VueAnalytics, {
      id: process.env.VUE_APP_GA,
      router,
      autoTracking: {
        exception: true,
      },
      debug: {
        enabled: !isProd,
        sendHitTask: isProd,
      },
    });
  }
  // eslint-disable-next-line
  new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App),
  });
});
